import { render, staticRenderFns } from "./KnowOri.vue?vue&type=template&id=2d72473c&scoped=true&"
import script from "./KnowOri.vue?vue&type=script&lang=js&"
export * from "./KnowOri.vue?vue&type=script&lang=js&"
import style0 from "./KnowOri.vue?vue&type=style&index=0&id=2d72473c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72473c",
  null
  
)

export default component.exports